import * as React from "react";
import { Input } from "./widget";
import { bind, Control, ControlProps } from "./Control";

const TextInput = (props: ControlProps) => {

    const id = props.name;
    const binding = bind(props);

    return <Control {...props}>
        <Input
            autoFocus={props.autoFocus}
            name={id}
            id={id}
            placeholder={props.placeholder}
            value={binding.value ?? ''}
            onChange={e => binding.onChange(e.currentTarget.value)} />
    </Control>;
}

export {
    TextInput
};
